import styled from 'styled-components';

import { fromLarge } from 'styleUtils/mediaQueries';
import { Exo } from 'styles/fonts';

interface Props {
    center?;
}
export const Heading = styled.h1<Props>`
    font-family: ${Exo};
    line-height: 34px;
    font-size: 20px;

    ${fromLarge`
        font-size: 30px;
    `};

    margin-bottom: 0;
    ${({ center }): string =>
        center &&
        `
            text-align: center;
        `}
`;
